<template>
  <nav class="navbar" :class="{'scrolled': scrolled}">
    <div class="container nav-container">
      <a href="#" class="logo" @click.prevent="scrollToTop">
        <!-- <svg class="icon" viewBox="0 0 24 24">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
        <span>国华未来智慧</span> -->
        <img style="height: 2.5rem;;" src="../assets/images/logo2.png" alt="" srcset="">
      </a>
      
      <ul class="nav-links" :class="{'active': menuOpen}">
      <li><a href="#home" @click.prevent="navigateTo('home')">首页</a></li>
        <li><a href="#product" @click.prevent="navigateTo('product')">产品介绍</a></li>
        <li><a href="#about" @click.prevent="navigateTo('about')">公司介绍</a></li>
        <li><a href="#contact" @click.prevent="navigateTo('contact')">联系我们</a></li>
      </ul>
      <div class="nav-actions">
        <a style="visibility: hidden;" href="#" class="btn btn-outline">登录</a>
        <button class="mobile-toggle" @click="toggleMenu">
          <svg v-if="!menuOpen" class="icon" viewBox="0 0 24 24">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </svg>
          <svg v-else class="icon" viewBox="0 0 24 24">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          </svg>
        </button>
      </div>
    </div>
  </nav>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { smoothScrollTo, scrollToTop } from '@/utils'
const scrolled = ref(false)
const menuOpen = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 50
}

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value
}
const navigateTo = (sectionId) => {
  // 移动端点击后关闭菜单
  if (menuOpen.value) {
    menuOpen.value = false
  }
  
  // 根据不同的sectionId设置不同的偏移量
  const offset = scrolled.value ? 70 : 120
  smoothScrollTo(sectionId, offset)
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
  transition: var(--transition);
}

.navbar.scrolled {
  padding: 10px 0;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--primary);
  text-decoration: none;
}

.logo .icon {
  width: 28px;
  height: 28px;
  margin-right: 8px;
  fill: var(--primary);
}

.nav-links {
  display: flex;
  list-style: none;
}

.nav-links li {
  margin-left: 30px;
}

.nav-links a {
  text-decoration: none;
  color: var(--dark);
  font-weight: 500;
  transition: var(--transition);
}

.nav-links a:hover {
  color: var(--primary);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.mobile-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--dark);
}

.mobile-toggle .icon {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

@media (max-width: 768px) {
  .nav-links {
    position: fixed;
    top: 70px;
    left: 0;
    width: 100%;
    background-color: white;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-150%);
    transition: var(--transition);
  }
  
  .nav-links.active {
    transform: translateY(0);
  }
  
  .nav-links li {
    margin: 15px 0;
  }
  
  .mobile-toggle {
    display: block;
  }
}
</style>